import React, { useCallback, useMemo, useState } from 'react';
import CardCom from '../../../components/CardCom/index.jsx';
import { cn } from '../../../utils/utils';
// import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Cascader, DatePicker, message, Modal, Select, Tabs } from 'antd';
import { deleteResponse, postCeleryTask, putResponse } from '../../../api/request.js';
import SvgCom from '../../../components/SvgCom/index.jsx';
import { ReactComponent as DeleteSvg } from '../../../assets/svgs/delete.svg';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import TextArea from 'antd/es/input/TextArea.js';

// import TestBg from '../../../assets/bg.png';

const tabItems = [
  {
    key: 'tab_1',
    label: 'Data',
  },
  // {
  //   key: 'tab_2',
  //   label: 'Labels',
  // },
  // {
  //   key: 'tab_3',
  //   label: 'Tags',
  // },
  // {
  //   key: 'tab_4',
  //   label: 'Themes',
  // },
  // {
  //   key: 'tab_5',
  //   label: 'Showreels',
  // },
];

const formObj = {
  geographic: {
    key: 'geographic',
    type: 'cascader',
    optionKey: 'geographic',
    value: null,
  },
  age: {
    key: 'age',
    type: 'select',
    optionKey: 'age',
    value: null,
  },
  dietary: {
    key: 'dietary',
    type: 'select',
    optionKey: 'dietary',
    value: null,
  },
  country: {
    key: 'country',
    type: 'cascader',
    optionKey: 'geographic',
    value: null,
  },
  date: {
    key: 'date',
    type: 'datetime',
    optionKey: 'date',
    value: null,
  },
  lifeStage: {
    key: 'lifeStage',
    type: 'select',
    optionKey: 'lifeStage',
    value: null,
  },
  sentiment: {
    key: 'sentiment',
    type: 'select',
    optionKey: 'sentiment',
    value: null,
  },
  socialClass: {
    key: 'socialClass',
    type: 'select',
    optionKey: 'socialClass',
    value: null,
  }
};

const ResponseCom = ({responseList = [], optionValueList, onRefreshDetail}) => {
  return (
    <div className={cn('grid gap-4')}>
      {
        responseList.map((item, index) => <TaskItemCom optionValueList={optionValueList} onRefreshDetail={onRefreshDetail} index={index} key={index} detailInfo={item}></TaskItemCom>)
      }
    </div>
  );
};

const TaskItemCom = ({detailInfo = {}, optionValueList, onRefreshDetail}) => {
  const [ isTranslated, setIsTranslated ] = useState(true);
  const [ editTranscription, setEditTranscription ] = useState(false);
  const [ newTranscription, setNewTranscription ] = useState('');

  const [ isEdit, setIsEdit ] = useState(false);
  const [ attributes, setAttributes ] = useState({
    age: detailInfo.age,
    dietary: detailInfo.dietary,
    country: detailInfo.country,
    date: detailInfo.date,
    geographic: detailInfo.geographic,
    lifeStage: detailInfo.lifeStage,
    sentiment: detailInfo.sentiment,
    socialClass: detailInfo.socialClass
  });
  // const [curQIndex, setCurQIndex] = useState(1);
  // const ref = useRef(null);

  // const pageChange = (type) => {
  //   const curNode = ref.current;
  //   if(!curNode) return;
  //   let scrollVal = 0;
  //   if(type === 'pre') {
  //     scrollVal = -350;
  //   } else {
  //     scrollVal = 350;
  //   }
  //   curNode.scrollTo({
  //     left: curNode.scrollLeft + scrollVal,
  //     behavior: 'smooth',
  //   });
  // };

  const curData = useMemo(() => {
    return attributes;
  }, [attributes]);

  const jsonData = useMemo(() => {
    const keys = Object.keys(curData);
    const tempAry = [];
    keys.forEach((item) => {
      tempAry.push({key: item, value: curData[item]});
    });
    return tempAry;
  }, [curData]);

  const fnEditAttrChange = (value, key) => {
    const tempObj = {...attributes};
    tempObj[key] = value;
    setAttributes(tempObj);
  };

  const fnSaveAttr = async() => {
    try {
      const tempObj = {...attributes};
      const params = {
        ...tempObj,
        attributes: tempObj
      };
      const result = await putResponse(detailInfo.id, params);
      if(result.status === 'Success') {
        setIsEdit(false);
        onRefreshDetail();
      }
    } catch(error) {
      // 
    }
  };

  const  fnPostCeleryTask = async (responseId, taskName) => {
    try {
      await postCeleryTask(responseId, taskName);
      message.info('Your request has been submitted. Please wait.');
    } catch(error) {
      //
    } finally {
      //
    }
  };

  const fnDelete = () => {
    Modal.confirm({
      title: 'Warning',
      icon: <ExclamationCircleOutlined />,
      content: 'Do you want to delete this record?',
      okText: 'Entry',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await deleteResponse(detailInfo.id);
          onRefreshDetail();
        } catch(error) {
          //
        } finally {
          //
        }
      }
    });
  };

  const cardTitle = useMemo(() => {
    return `${detailInfo?.id}${detailInfo?.name ? ` - ${detailInfo?.name}` : ''}${detailInfo?.age ? ` - ${detailInfo?.age}` : ''}${detailInfo?.location ? ` - ${detailInfo?.location}` : ''}`;
  }, []);

  const fnEditTranceription = useCallback(async () => {
    try {
      let params = {};
      if(isTranslated) {
        params = {
          transcription_translated: newTranscription
        };
      } else {
        params = {
          transcription: newTranscription
        };
      }
      const result = await putResponse(detailInfo.id, params);
      if(result.status === 'Success') {
        setEditTranscription(false);
        onRefreshDetail();
      }
    } catch(error) {
      console.log(error);
    }
  }, [newTranscription, isTranslated]);

  return <CardCom label={cardTitle} rightNode={<SvgCom onClick={fnDelete} Svg={DeleteSvg} size="20" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>}>
    <div className="flex justify-start">
      <div>
        <video className="w-[350px]" autoPlay={false} muted loop controls src={detailInfo?.video_url} preload="true"></video>
        {/* <div className="w-[350px] h-[80px] relative mt-3">
          <div onClick={() => pageChange('pre')} className="h-full flex justify-center items-center text-primary text-2xl cursor-pointer absolute left-0 z-10">
            <LeftOutlined />
          </div>

          <div onClick={() => pageChange('next')} className="h-full flex justify-center items-center text-primary text-2xl cursor-pointer absolute right-0 z-10">
            <RightOutlined />
          </div>
          <div ref={ref} className="w-full whitespace-nowrap overflow-x-auto">
            {
              [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map((item, index) => <div key={index} onClick={() => setCurQIndex(index)} className="w-[80px] inline-block relative overflow-hidden rounded-md mr-2 cursor-pointer">
                <img src={TestBg} className="w-full h-full" alt="" />
                <span className="px-[6px] py-[3px] text-[10px] leading-none bg-primary text-white font-normal rounded-3xl absolute top-[5px] left-[5px]">Q{item}</span>
                {
                  curQIndex !== index && <div className="bg-white opacity-50 w-full h-full absolute top-0 left-0"></div>
                }
              </div>)
            }
          </div>
        </div> */}
      </div>
      <div className="flex-1 ml-[20px]">
        <div className='flex justify-between items-center'>
          <div className='flex items-center justify-start'>
            <div className="w-fit bg-primary text-base leading-none font-bold text-white py-[7px] px-[14px] rounded-3xl">Question {detailInfo?.id}</div>
            
            <Button size="small"  className='text-primary ml-3' onClick={() => setIsTranslated(!isTranslated)}>Switch To { isTranslated ? 'Original' : 'Translated' }</Button>
          </div>
          <button className="border-btn ml-2" onClick={() => fnPostCeleryTask(detailInfo.id, 'process_response_transcription')}>
            <span className="mr-2">Transcribe</span>
          </button>
        </div>
        <div className="my-[13px] text-primary text-base font-semibold">{detailInfo?.title}</div>
        <div className='flex items-center justify-start mb-2'>
          {
            editTranscription ? <div className='flex items-center justify-start'>
              <Button size="small"  className='text-primary mr-2' onClick={() => setEditTranscription(false)}>Cancel</Button>
              <Button type="primary" size="small"  className='mr-2' onClick={() => fnEditTranceription()}>Save</Button>
            </div> : <Button size="small"  className='text-primary mr-2' onClick={() => {
              setNewTranscription(isTranslated ? detailInfo?.transcription_translated : detailInfo?.transcription);
              setEditTranscription(true);
            }}>Edit Transcription</Button>
          }
        </div>
        {
          !editTranscription && <div className="text-sm text-green-1 whitespace-break-spaces">
            {
              isTranslated ? detailInfo?.transcription_translated : detailInfo?.transcription
            }
          </div>
        }

        {
          editTranscription && <TextArea autoSize value={newTranscription} onChange={(e) => setNewTranscription(e.target.value)} className='!w-full'></TextArea>
        }

        <Tabs defaultActiveKey="1" items={tabItems} tabBarExtraContent={
          isEdit ? <div className='flex items-center'>
            <Button size="small" className='text-primary mr-2' onClick={() => setIsEdit(false)}>Cancel</Button>
            <Button type="primary" size="small" className='' onClick={fnSaveAttr}>Save</Button>
          </div> : <Button size="small"  className='text-primary' onClick={() => setIsEdit(true)}>Edit</Button>
        } className="tab-custom [&>div.ant-tabs-nav]:before:border-[#00A32E1A] [&>div.ant-tabs-nav]:before:border-[1.5px] [&>div.ant-tabs-nav]:mb-0" />
        <div className="mt-5 text-sm text-green-1 font-normal [&>div>div.resonse-label]:w-1/3">
          {
            jsonData.map((item, index) => <div key={index} className="flex justify-start items-center mb-1">
              <div className="resonse-label font-semibold mr-2 capitalize">{item.key}</div>
              {/* <Input disabled={!isEdit} placeholder={item.key === 'date' ? 'YYYY/MM/DD' : ''} onChange={(e) => fnEditAttrChange(e.target.value, item.key)} value={item.value}></Input> : */}
              {
                isEdit ? <>
                  {
                    formObj[item.key]['type'] == 'select' ? <Select
                      value={item.value}
                      allowClear
                      onChange={(value) => fnEditAttrChange(value, item.key)}
                      placeholder="Please select"
                      className='!w-full'
                      options={optionValueList[formObj[item.key]['optionKey']] || []}
                    /> :
                      formObj[item.key]['type'] == 'cascader' ? <Cascader 
                        value={item.value}
                        allowClear 
                        onChange={(value) => {
                          const realValue = value[value.length - 1];
                          fnEditAttrChange(realValue, item.key);
                        }} className='!w-full' options={optionValueList[formObj[item.key]['optionKey']] || []} placeholder="Please select" /> :
                        formObj[item.key]['type'] == 'datetime' ? <DatePicker
                          value={dayjs(item.value)}
                          format="YYYY-MM-DD"
                          className='!w-full'
                          placeholder='YYYY-MM-DD'
                          onChange={(date) => {
                            const formatDate = date.format('YYYY-MM-DD');
                            fnEditAttrChange(formatDate, item.key);
                          }} /> : <></>
                  }
                </> : <div className='flex-1 whitespace-break-spaces break-all'>{item.value}</div>
              }
            </div>)
          }
        </div>
      </div>
    </div>
  </CardCom>;
};

export default ResponseCom;